<template>
  <div class="title" :class="{'is-border':isBorder}">
    <h2 class="title-inner">
      <slot></slot>
    </h2>
  </div>
</template>
<script>
export default {
  props: ['border'],
  data(){
    return {
      isBorder:typeof this.border !=='undefined'
    }
  },
}
</script>

<style scoped lang="scss">
.title {
  padding: 20px;
}

.title-inner {
  padding-left: 10px;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
  margin: 0;
  border-left: 3px solid #1fb09f;
}

.is-border{
  border:1px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/title.vue